export default [
  {
    type: 'awe',
    class: 'ad',
    name: 'Ad',
  },
  {
    type: 'awe',
    class: 'address-book',
    name: 'AddressBook',
  },
  {
    type: 'awe',
    class: 'address-card',
    name: 'AddressCard',
  },
  {
    type: 'awe',
    class: 'adjust',
    name: 'Adjust',
  },
  {
    type: 'awe',
    class: 'air-freshener',
    name: 'AirFreshener',
  },
  {
    type: 'awe',
    class: 'align-center',
    name: 'AlignCenter',
  },
  {
    type: 'awe',
    class: 'align-justify',
    name: 'AlignJustify',
  },
  {
    type: 'awe',
    class: 'align-left',
    name: 'AlignLeft',
  },
  {
    type: 'awe',
    class: 'align-right',
    name: 'AlignRight',
  },
  {
    type: 'awe',
    class: 'allergies',
    name: 'Allergies',
  },
  {
    type: 'awe',
    class: 'ambulance',
    name: 'Ambulance',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-alarm',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-apartment',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-arrow-down',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-arrow-down-circle',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-arrow-left',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-arrow-left-circle',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-arrow-right',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-arrow-right-circle',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-arrow-up',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-arrow-up-circle',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-bicycle',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-bold',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-book',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-bookmark',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-briefcase',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-bubble',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-bug',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-bullhorn',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-bus',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-calendar-full',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-camera',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-camera-video',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-car',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-cart',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-chart-bars',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-checkmark-circle',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-chevron-down',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-chevron-down-circle',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-chevron-left',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-chevron-left-circle',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-chevron-right',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-chevron-right-circle',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-chevron-up',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-chevron-up-circle',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-circle-minus',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-clock',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-cloud',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-cloud-check',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-cloud-download',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-cloud-sync',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-cloud-upload',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-code',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-coffee-cup',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-cog',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-construction',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-crop',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-cross',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-cross-circle',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-database',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-diamond',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-dice',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-dinner',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-direction-ltr',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-direction-rtl',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-download',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-drop',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-earth',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-enter',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-enter-down',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-envelope',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-exit',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-exit-up',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-eye',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-file-add',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-file-empty',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-film-play',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-flag',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-frame-contract',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-frame-expand',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-funnel',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-gift',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-graduation-hat',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-hand',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-heart',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-heart-pulse',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-highlight',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-history',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-home',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-hourglass',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-inbox',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-indent-decrease',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-indent-increase',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-italic',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-keyboard',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-laptop',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-laptop-phone',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-layers',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-leaf',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-license',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-lighter',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-line-spacing',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-linearicons',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-link',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-list',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-location',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-lock',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-magic-wand',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-magnifier',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-map',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-map-marker',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-menu',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-menu-circle',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-mic',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-moon',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-move',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-music-note',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-mustache',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-neutral',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-page-break',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-paperclip',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-paw',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-pencil',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-phone',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-phone-handset',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-picture',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-pie-chart',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-pilcrow',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-plus-circle',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-pointer-down',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-pointer-left',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-pointer-right',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-pointer-up',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-poop',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-power-switch',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-printer',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-pushpin',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-question-circle',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-redo',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-rocket',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-sad',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-screen',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-select',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-shirt',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-smartphone',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-smile',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-sort-alpha-asc',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-sort-amount-asc',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-spell-check',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-star',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-star-empty',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-star-half',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-store',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-strikethrough',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-sun',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-sync',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-tablet',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-tag',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-text-align-center',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-text-align-justify',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-text-align-left',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-text-align-right',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-text-format',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-text-format-remove',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-text-size',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-thumbs-down',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-thumbs-up',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-train',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-trash',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-underline',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-undo',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-unlink',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-upload',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-user',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-users',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-volume',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-volume-high',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-volume-low',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-volume-medium',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-warning',
  },
  {
    type: 'lnr',
    class: 'lnr lnr-wheelchair ',
  },
];
